export const PARAMETRO_REDIRECT_APOS_LOGIN = 'redirect'
const CHAVE_REDIRECT_APOS_LOGIN = 'pontotel:redirect-apos-login'

function normalizarRota (rota) {
  return rota?.value || rota
}

export function rotaPermiteRedirectAposLogin (fullPath) {
  return [
    '/biometria/autenticar',
    '/gerenciamento-de-arquivos/list'
  ].includes(fullPath)
}

export function obterRotaDeLoginComRedirect (rota) {
  const rotaNormalizada = normalizarRota(rota)
  const redirect = rotaNormalizada?.fullPath

  if (!rotaPermiteRedirectAposLogin(redirect)) {
    return '/cognito/login'
  }

  return {
    path: '/cognito/login',
    query: {
      [PARAMETRO_REDIRECT_APOS_LOGIN]: redirect
    }
  }
}

export function obterRotaDeLoginAposLogout (rota) {
  const rotaLogin = obterRotaDeLoginComRedirect(rota)
  const query = rotaLogin.query || {}

  return {
    path: '/cognito/login',
    query: {
      ...query,
      autologin: 'false'
    }
  }
}

export function obterRedirectAposLogin (route) {
  const redirect = route?.query?.[PARAMETRO_REDIRECT_APOS_LOGIN]

  if (!rotaPermiteRedirectAposLogin(redirect)) {
    return '/'
  }

  return redirect
}

export function salvarRedirectAposLogin (route) {
  try {
    const redirect = route?.query?.[PARAMETRO_REDIRECT_APOS_LOGIN]

    if (!rotaPermiteRedirectAposLogin(redirect)) {
      sessionStorage.removeItem(CHAVE_REDIRECT_APOS_LOGIN)
      return
    }

    sessionStorage.setItem(CHAVE_REDIRECT_APOS_LOGIN, redirect)
  } catch {}
}

export function consumirRedirectAposLoginSalvo () {
  try {
    const redirect = sessionStorage.getItem(CHAVE_REDIRECT_APOS_LOGIN)
    sessionStorage.removeItem(CHAVE_REDIRECT_APOS_LOGIN)

    if (!rotaPermiteRedirectAposLogin(redirect)) {
      return null
    }

    return redirect
  } catch {
    return null
  }
}
